/* eslint-disable import/prefer-default-export */
export class FileDownloadHelper {
  static downloadFile = (response: any, fileName: string) => {
    if (response && response.data) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.target = '_blank';
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
    }
  };
}
